import styled from "styled-components";

export const TableBookingReserveStyled = styled.div`
  width: 100%;
  overflow: visible;

  .table_scroll_x {
    width: 100%;
    overflow-x: auto;
    overflow-y: visible;
  }
  .table_info {
    margin-bottom: 21px;

    width: 100%;
    min-width: max-content;
    border-collapse: collapse;
    .checkbox_header {
      width: 15%;
      text-align: left;
      font-size: ${({ theme }) => theme.FONT.SIZE.S16};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_SEMIBOLD};
      color: ${({ theme }) => theme.COLORS.BLACK_1};
    }
    .table_header {
      border: 1px solid ${({ theme }) => theme.COLORS.GRAY_8};
      font-size: ${({ theme }) => theme.FONT.SIZE.S16};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_SEMIBOLD};
      color: ${({ theme }) => theme.COLORS.BLACK_1};
    }
    .checkbox {
      display: flex;
      column-gap: 17px;
    }
    .table_detail {
      border: 1px solid ${({ theme }) => theme.COLORS.GRAY_8};
    }
    .table_detail_gray {
      border: 1px solid ${({ theme }) => theme.COLORS.GRAY_8};
      background: ${({ theme }) => theme.COLORS.GRAY_10};
    }
  }
  

  .theme_standard {
  }
`;
